import ScreenProcessorRuleUpdate from 'screens/ProcessorRule/Update';
import ScreenProcessorRuleCreate from 'screens/ProcessorRule/Create';
import ScreenProcessorRuleDetails from 'screens/ProcessorRule/Details';
import ScreenProcessorRuleList from 'screens/ProcessorRule/List';
import { PROCESSOR_RULE } from 'routes/paths';

const processorRulesRoutes = [
  {
    path: PROCESSOR_RULE.UPDATE,
    name: 'ProcessorRuleUpdate',
    component: ScreenProcessorRuleUpdate,
    allowPermissions: ['change_processorrule'],
  },
  {
    path: PROCESSOR_RULE.CREATE,
    name: 'ProcessorRuleCreate',
    component: ScreenProcessorRuleCreate,
    allowPermissions: ['add_processorrule'],
  },
  {
    path: PROCESSOR_RULE.DETAILS,
    name: 'ProcessorRuleDetails',
    component: ScreenProcessorRuleDetails,
    allowPermissions: ['view_processorrule'],
  },
  {
    path: PROCESSOR_RULE.LIST,
    name: 'ProcessorRuleList',
    component: ScreenProcessorRuleList,
    loginRequired: true,
    allowPermissions: ['list_processorrule'],
  },
];

export default processorRulesRoutes;
